<template>
  <div class="vx-card mb-8">
    <div class="vx-card__body">
      <form>
        <div class="vx-row">
          <div class="vx-col lg:w-3/4 sm:w-2/3 w-full">
            <label class="vs-select--label">{{ $t("Product") }}</label>
            <treeselect
              v-model="transaction.stockId"
              name="stockid"
              :multiple="false"
              :placeholder="$t('Search')"
              :async="true"
              :load-options="loadOptions"
              :class="{ 'is-invalid': errors.has('stockid') }"
              v-validate="'required'"
              @select="onStockSelected"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              placeholder="-"
              v-model="transaction.stockTypeName"
              :label="$t('Type')"
              readonly="readonly"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("OriginInventory") }}</label>
            <v-select
              label="name"
              name="shelve"
              :options="shelves"
              v-model="transaction.shelveId"
              :reduce="(x) => x.id"
              v-validate="'required'"
              :class="{ 'is-invalid': errors.has('shelve') }"
              dir="rtl"
              :key="shelveIdControl"
            >
            </v-select>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <label class="vs-select--label">{{
              $t("DestinationInventory")
            }}</label>
            <v-select
              label="name"
              name="destinationShelve"
              :options="destinationShelves"
              v-model="transaction.destinationShelveId"
              :reduce="(x) => x.id"
              v-validate="'required'"
              :class="{ 'is-invalid': errors.has('destinationShelve') }"
              dir="rtl"
              :key="shelveIdControl"
            >
            </v-select>
          </div>

          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <vs-input
              v-model="transaction.count"
              name="pcount"
              :label="$t('Count')"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
              :class="{ 'is-invalid': errors.has('pcount') }"
            />
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-plus"
              id="add-btn"
              @click.prevent="uiAddTransaction()"
              >{{ $t("Add") }}</vs-button
            >
          </div>
        </div>
      </form>

      <vs-table :data="inventoryTransactions" class="custom-tbl">
        <template slot="thead">
          <th style="width: 5%">#</th>
          <th style="width: 40%">{{ $t("Product") }}</th>
          <th style="width: 5%">{{ $t("Count") }}</th>
          <th style="width: 15%">{{ $t("OriginInventory") }}</th>
          <th style="width: 15%">{{ $t("DestinationInventory") }}</th>
          <th style="width: 20%">{{ $t("Action") }}</th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="i" v-for="(index, i) in data">
            <vs-td>
              {{ i + 1 }}
            </vs-td>
            <vs-td>
              {{ data[i].name }}
            </vs-td>
            <vs-td>
              {{ data[i].count }}
            </vs-td>

            <vs-td>
              {{ data[i].shelveName }}
            </vs-td>
            <vs-td>
              {{ data[i].destinationShelveName }}
            </vs-td>

            <vs-td>
              <span v-if="data[i].stockType == 1">
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="serial-btn"
                  @click="addSerial(i)"
                  >{{ $t("SerialNumbers") }}</vs-button
                >
              </span>
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="deleteInventoryItem(i)"
                class="d-inline remove-btn"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <serial-popup
        :show="SerialPopup"
        @finish="onfinish"
        @close="closeSerialPopup"
        :serialRowIndex="serialRowIndex"
      ></serial-popup>
    </div>
  </div>
</template>
<style lang="scss">
.vs-input--label {
  margin-top: 6px;
  margin-bottom: 2px;
  display: block;
}

.remove-btn {
  float: left !important;
  margin-top: 3px;
}

#add-btn {
  background: transparent;
  padding: 0.5rem 0.1rem;
  width: 100%;
  border: none;
  color: #fff;
  background: linear-gradient(
    30deg,
    rgba(var(--vs-success), 1),
    rgba(var(--vs-success), 0.6)
  ) !important;
  text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  margin-top: 1.85rem;
  text-align: center;
}
#add-btn i {
  margin-right: 0px;
  margin-left: 5px;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_warehouse.scss";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import SerialPopup from "./SerialPopup.vue";

const dict = {
  custom: {
    shelve: {
      required: "لطفا نام انبار را انتخاب نمایید.",
    },
    date: {
      required: "لطفا تاریخ ثبت را انتخاب نمایید.",
    },
  },
};

Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_TransferTransactions_ProductAttach",
  components: {
    "v-select": vSelect,
    Treeselect,
    SerialPopup,
  },
  data() {
    return {
      pcount: "",
      shelve: "",
      shelveIdControl: 0,
      transaction: {},
      stockTypeName: "-",
      SerialPopup: false,
      serialRowIndex: "",
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    ...mapGetters({
      model: "transferTransactions/model",
      inventoryTransactions: "transferTransactions/inventoryTransactions",
      selectedTransactionSerialsCountLessThanEnteredCount:
        "transferTransactions/selectedTransactionSerialsCountLessThanEnteredCount",
    }),
    shelves() {
      var warehouse = this.$store.getters["warehouse/list"].find(
        (obj) => obj.id == this.model.storeId
      );
      return warehouse ? warehouse.shelveQueries : [];
    },
    destinationShelves() {
      var destinationWarehouse = this.$store.getters["warehouse/list"].find(
        (obj) => obj.id == this.model.destinationStoreInfoCommand.storeId
      );
      return destinationWarehouse ? destinationWarehouse.shelveQueries : [];
    },
  },
  mounted() {
    this.setEmptyModel();
  },
  methods: {
    ...mapActions({
      addTransaction: "transferTransactions/addTransaction",
      setSelectedTransactionIndex:
        "transferTransactions/setSelectedTransactionIndex",
      fetchSearch: "stock/fetchSearch",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.stockId,
                  label: element.stockName,
                  stockType: element.stockType,
                  stockTypeName: element.stockType == 1 ? "سریالی" : "مقداری",
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    uiAddTransaction() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.transaction.shelveName = this.shelves.filter(
            (x) => x.id == this.transaction.shelveId
          )[0].name;
          this.transaction.destinationShelveName =
            this.destinationShelves.filter(
              (x) => x.id == this.transaction.destinationShelveId
            )[0].name;
          this.addTransaction(Object.assign({}, this.transaction));
          this.setEmptyModel();
          this.$validator.reset();
        }
      });
    },
    closeSerialPopup() {
      this.SerialPopup = false;
    },
    onfinish() {
      this.closeSerialPopup();
      if (this.selectedTransactionSerialsCountLessThanEnteredCount) {
        this.$swal({
          title:
            "تعداد سریال های وارد شده در جدول با سریال های ورودی متفاوت است!",
          type: "info",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "بستن",
        });
      }
      else{
        this.$emit("notDisable");

      }
    },
    addSerial(index) {
      this.setSelectedTransactionIndex(index);
      this.SerialPopup = true;
      this.serialRowIndex = index;
    },
    deleteInventoryItem(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.inventoryTransactions.splice(index, 1),
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
        }
      });
    },
    setEmptyModel() {
      this.transaction = {
        shelveId: null,
        shelveName: null,
        stockId: null,
        stockType: null,
        destinationShelveId: null,
        destinationShelveName: null,
      };
      this.shelveIdControl = Math.random();
    },
    onStockSelected(data) {
      this.transaction.name = data.label;
      this.transaction.stockType = data.stockType;
      this.transaction.stockTypeName = data.stockTypeName;
    },
  },
};
</script>
